import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgxCurrencyInputMode } from 'ngx-currency';
import { Router } from '@angular/router';

import { EmployeeService } from './../../../pages/employee/services/employee.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { UtilityService } from '../../../core/services/utility.service';
import { ReadOnlyPdfViewerComponent, FileInfo } from 'src/app/shared/component/read-only-pdf-viewer/read-only-pdf-viewer.component';
import { EmployeeInfo } from '../../../type-definitions/home/responses/home';
import { EmployeeApiService } from '../../../pages/employee/services/employee.api.service';
import { HomeApiService } from '@pages/home/services/home.api.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css'],
  providers: [],
})
export class ConfirmationModalComponent implements OnInit {
  @Input() data: any;
  @Input() errorMsg: string;
  @ViewChild(ReadOnlyPdfViewerComponent) ReadOnlyPdfViewerComponent: ReadOnlyPdfViewerComponent;
  expenseData: { [key: string]: any } = {};
  options: { [key: string]: any } = {};
  currencySymbol: string;
  format: string;
  portalSettings: any;
  employeeInfo: EmployeeInfo;
  formData: { [key: string]: any } = {};
  extenion: string;
  isOpen: any[];
  savedFiles: any[];
  newFiles: any[];
  expensePostingType: string;
  attachmentList: any[];
  bdatePickerOptions: {
    dateInputFormat: string;
    containerClass: string;
    showTodayButton: boolean;
    showClearButton: boolean;
    clearPosition: string;
    showWeekNumbers: boolean;
  };
  mobileMode: boolean;
  catList: any[] = [];
  showExpenseCategory = false;
  printMode = 'NewWindow';
  downloadURL: string | null = null;
  fileIsNotViewable = true;
  attachmentData: FileInfo = null;
  constructor(
    public activeModal: NgbActiveModal,
    portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    private employeeService: EmployeeService,
    private employeeApiService: EmployeeApiService,
    private utilityService: UtilityService,
    private router: Router,
    private homeApiService: HomeApiService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.format = utilityService.getDateFormat().toUpperCase();
    this.mobileMode = utilityService.isMobileMode();
  }

  ngOnInit(): void {
    this.bdatePickerOptions = {
      dateInputFormat: this.format.toUpperCase(),
      containerClass: 'theme-blue',
      showTodayButton: true,
      showClearButton: true,
      clearPosition: 'left',
      showWeekNumbers: false,
    };
    this.formData.selectedAttachment = {};
    this.getExpenseModel();
    this.getCatg();
    this.showExpenseCategory = this.portalSettings.ExShowExpenseCategory.ConfigValue == '1';
    this.expensePostingType = this.portalSettings.ExpensePostingType.ConfigValue;
    this.currencySymbol = this.utilityService.getCurrencySymbol(this.employeeInfo.PRCo);
    this.options = { align: 'left', prefix: this.currencySymbol, precision: 2, nullable: true, inputMode: NgxCurrencyInputMode.Natural };
  }

  getExpenseModel(): void {
    const requestParam = 'receiptID=' + this.data.newID + '&returnMode=E';
    this.employeeService.getExpenseReceipts(requestParam).then((response: any) => {
      this.expenseData = response[0];
      this.expenseData.ExpenseDate = new Date();
      this.expenseData.ReceiptItemID = this.data.receiptItemID;
      this.getAttachment();
    });
  }

  getCatg(): void {
    this.openModal();
    this.employeeApiService.getCategory().subscribe(response => {
      if (response != null) {
        this.catList = response.filter(val => val.IsActive);
      }
    });
    this.closeModal();
  }

  async getAttachment(): Promise<void> {
    this.savedFiles = [];
    this.newFiles = [];
    this.savedFiles = await this.employeeService.getLineAttachments(this.expenseData.ReceiptID, null);
    if (this.savedFiles && this.savedFiles.length > 0) {
      this.formData.selectedAttachment = this.savedFiles[0];
      this.getAttachmentData();
    } else {
      this.attachmentData = null;
    }
    this.attachmentList = [];
    this.savedFiles.forEach((val: { AttachmentFileName: string }) => {
      const tempExten = val.AttachmentFileName.slice(val.AttachmentFileName.lastIndexOf('.'), val.AttachmentFileName.length);
      if (
        tempExten.toLowerCase() == '.jpg' ||
        tempExten.toLowerCase() == '.jpeg' ||
        tempExten.toLowerCase() == '.png' ||
        tempExten.toLowerCase() == '.tif' ||
        tempExten.toLowerCase() == '.tiff'
      )
        this.attachmentList.push(val);
    });
  }

  public getAttachmentData(): void {
    this.homeApiService.getPdfFile(this.formData.selectedAttachment.FileAttachmentID).subscribe(
      (response: Blob) => {
        this.attachmentData = {
          ID: this.formData.selectedAttachment.FileAttachmentID,
          Name: this.formData.selectedAttachment.AttachmentFileName,
          Data: response,
        };
      },
      (error) => {
        this.attachmentData = {
          ID: this.formData.selectedAttachment.FileAttachmentID,
          Name: this.formData.selectedAttachment.AttachmentFileName,
          Data: null,
        };
      }
    );
  }

  async openEditExpenseReceipt(): Promise<void> {
    this.openModal();
    try {
      const response = await this.employeeService.insertUpdateReceipt(
        this.expenseData.ReceiptID,
        this.data.userKeyID,
        this.employeeInfo.PRCo,
        this.expenseData.ReceiptDescription,
        moment(this.expenseData.ExpenseDate, this.format.toUpperCase()).format('YYYY-MM-DD'),
        this.expenseData.ExpenseCatgID,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.expenseData.Amount
      );

      await this.employeeService.insertUpdateReceiptItem(this.data.receiptItemID, response.ReceiptID, this.expenseData.Amount || 0);
      this.closeModal();
      this.activeModal.dismiss();
      this.router.navigate(['/employee/editexpensereceipt/'], {
        fragment: `receiptID/${response.ReceiptID}/proxyuserID/${this.data.userKeyID}`,
      });
    } catch (error) {
      this.errorMsg = error?.error?.error ?? 'An error has occured.';
    }
  }

  async cancelClicked(): Promise<void> {
    this.openModal();

    try {
      const response = await this.employeeService.insertUpdateReceipt(
        this.expenseData.ReceiptID,
        this.data.userKeyID,
        this.employeeInfo.PRCo,
        this.expenseData.ReceiptDescription,
        moment(this.expenseData.ExpenseDate, this.format.toUpperCase()).format('YYYY-MM-DD'),
        this.expenseData.ExpenseCatgID,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.expenseData.Amount
      );
      await this.employeeService.insertUpdateReceiptItem(this.data.receiptItemID, response.ReceiptID, this.expenseData.Amount || 0);
      this.activeModal.close('close');
      this.closeModal();
    } catch (error) {
      this.errorMsg = error?.error?.error ?? 'An error has occured.';
    }
  }

  openModal(): void {
    document.getElementById('modalShare').style.display = 'block';
    document.getElementById('fadeShare').style.display = 'block';
  }

  closeModal(): void {
    document.getElementById('modalShare').style.display = 'none';
    document.getElementById('fadeShare').style.display = 'none';
  }
}
